gsap.registerPlugin(ScrollTrigger);


gsap.from(".hero-title", {
  opacity: 0,
  y: 40,
  duration: 0.8,
  ease: "power2.out",
  delay: 0.1        // маленькая задержка, по желанию
});

// Таймлайн для героя
const tl = gsap.timeline({
  scrollTrigger: {
    trigger: ".hero",
    start: "top top",
    end: "+=180%",    // чуть больше «длины» по скроллу
    scrub: 1.1,       // лёгкая инерция (не мгновенно за скроллом)
    pin: true
  }
});


// 2. Исчезновение тайтла
tl.to(".hero-title", {
  opacity: 0,
  y: -40,
  duration: 0.6,
  ease: "power2.inOut"
}, "+=0.15");

// 3. Плавное проявление блока с батончиками
tl.to(".bars", {
  opacity: 1,
  duration: 0.5,
  ease: "power1.out"
}, "<"); // одновременно с исчезновением тайтла

// 4. Прилет 4-х рядов батончиков навстречу друг другу
// 1 и 3 — справа
tl.from(".bars-row.row-1, .bars-row.row-3", {
  xPercent: 140,       // летят чуть издалека
  opacity: 0,
  duration: 1.2,
  ease: "power3.out",
  stagger: 0.08        // маленькая задержка между рядами
}, "-=0.1");

// 2 и 4 — слева
tl.from(".bars-row.row-2, .bars-row.row-4", {
  xPercent: -140,
  opacity: 0,
  duration: 1.2,
  ease: "power3.out",
  stagger: 0.08
}, "<0.1");

// 5. Общее мягкое «притормаживание» + выравнивание
// 1 и 3 проходят чуть больший путь по X, но всё ещё в рамках одной фазы
tl.to(".bars-row", {
  xPercent: 0,
  duration: 0.7,
  ease: "power2.out"
}, "-=0.4");

// легкое «досаживание» к финальной позиции
tl.to(".bars-row", {
  xPercent: 0,
  duration: 0.5,
  ease: "power1.out"
});

// параллельно выравниваем общий наклон
tl.to(".bars", {
  rotate: 0,
  scale: () => window.innerWidth <= 768 ? 0.7 : 1, 
  duration: 1.0,
  ease: "power2.out"
}, "<-0.4");

//secction 2

const benefitsTl = gsap.timeline({
  scrollTrigger: {
    trigger: ".benefits",
    start: "top 50%",         // когда секция попадает в зону
    toggleActions: "play none none reverse"
  }
});

// Левая колонка — общий блок
benefitsTl.from(".benefits-images", {
  x: -60,
  opacity: 0,
  duration: 1.0,
  ease: "power3.out"
});

// Внутренние картинки — чуть по-разному
benefitsTl.from(".benefits-img--top", {
  y: 30,
  duration: 0.7,
  ease: "power2.out"
}, "<0.1");

benefitsTl.from(".benefits-img--bottom", {
  y: 40,
  scale: 0.96,
  duration: 0.7,
  ease: "power2.out"
}, "<0.05");

// Правая часть — текст
benefitsTl.from([".benefits-title", ".benefits-subtitle"], {
  y: 30,
  opacity: 0,
  duration: 0.7,
  ease: "power2.out",
  stagger: 0.1
}, "<0.1");

// Шаги — по очереди
benefitsTl.from(".benefits-step", {
  x: 30,
  opacity: 0,
  duration: 0.6,
  ease: "power2.out",
  stagger: 0.15
}, "<0.1");

// Кнопка
benefitsTl.from(".benefits-cta", {
  y: 26,
  opacity: 0,
  scale: 0.96,
  duration: 0.5,
  ease: "power2.out"
}, "<0.1");